// removed by extract-text-webpack-plugin
module.exports = {"fadein":"index__fadein__MHKQ_"};


//////////////////
// WEBPACK FOOTER
// ./src/index.css
// module id = 447
// module chunks = 0